<div class="bg-white rounded-lg py-3 mb-6">
  <div class="flex justify-between items-center mt-3 mb-6 px-6">
    <h1 class="font-semibold">Notification Settings</h1>
    <!-- <button class="bg-[#D9D9D9] rounded-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_1958_7961)">
          <path
            d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
            fill="#6C757D"
          />
        </g>
        <defs>
          <clipPath id="clip0_1958_7961">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </button> -->
  </div>
  <!-- <div class="grid grid-cols-12 border-t-2 pt-4 px-6 gap-8"> -->
  <div class="flex gap-6 border-t-2w-full">
    <div class="flex items-center gap-4 p-6 border-t-2">
      <!-- <input type="checkbox" class="w-full border p-2 rounded-md outline-none" placeholder="Enter mobile number" formControlName="mobile"> -->
      <input
        class="bg-transparent border-none"
        type="checkbox"
        class="w-[24px] h-[24px]"
        [(ngModel)]="sms"
        ngDefaultControl
      />
      <span> Active SMS Service</span>
    </div>
    <div class="flex items-center gap-4 p-6">
      <!-- <input type="checkbox" class="w-full border p-2 rounded-md outline-none" placeholder="Enter mobile number" formControlName="mobile"> -->
      <input
        class="bg-transparent border-none"
        type="checkbox"
        class="w-[24px] h-[24px]"
        [(ngModel)]="sms"
        ngDefaultControl
      />
      <span>Active SMS Email Service</span>
    </div>
  </div>
  <!-- <div
            class="flex w-full flex-col bg-white py-2 rounded-xl"
            >
            <div
                class="flex w-full justify-between bg-[#F1F1F1] rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
            >
                <div class="flex gap-4 items-center">
                <div class="h-10 w-1 bg-primary"></div>
                <span>Notification Engine</span>
                </div>
            </div>
            <div class="p-5 grid md:grid-cols-2 grid-col-1 gap-4 w-full">
                <div class="w-full gap-2 flex my-2">
                    <input
                    class="bg-transparent border-none"
                    type="checkbox"
                    class="w-[24px] h-[24px]"
                    />
                    <span>Customer Authentication Emailer</span>
                </div>
                <div class="w-full gap-2 flex my-2">
                    <input
                    class="bg-transparent border-none"
                    type="checkbox"
                    class="w-[24px] h-[24px]"
                    ngDefaultControl
                    />
                    <span>Customer Transaction Emailer</span>
                </div>
                <div class="w-full gap-2 flex my-2">
                    <input
                    class="bg-transparent border-none"
                    type="checkbox"
                    class="w-[24px] h-[24px]"
                    ngDefaultControl
                    />
                    <span>Customer Refund Emailer</span>
                </div>
                <div class="w-full gap-2 flex my-2">
                    <input
                    class="bg-transparent border-none"
                    type="checkbox"
                    class="w-[24px] h-[24px]"
                    ngDefaultControl
                    />
                    <span>Merchant Transaction Emailer</span>
                </div>
                <div class="w-full gap-2 flex my-2">
                    <input
                    class="bg-transparent border-none"
                    type="checkbox"
                    class="w-[24px] h-[24px]"
                    ngDefaultControl
                    />
                    <span>Merchant Refund Emailer</span>
                </div>
            </div>
            <div class="w-full gap-2 flex px-5 my-2">
                <input
                class="bg-transparent border-none"
                type="checkbox"
                class="w-[24px] h-[24px]"
                formControlName="TransactionFailedAlert"
                ngDefaultControl
                />
                <span>Transaction Failed Alert</span>
            </div>
            <div class="p-5 gap-4 flex flex-col md:flex-row">
                <div class="w-full gap-2 flex flex-col">
                <span>Merchant Transaction Email</span>

                <input
                    formControlName="MerchantTransactionEmailID"
                    name="MerchantTransactionEmailID"
                    placeholder="Merchant Transaction Email"
                    class="w-full border p-2 rounded-md outline-none"
                />
                <div
                    *ngIf="customerNotificationForm.controls['MerchantTransactionEmailID'].errors?.['email']"
                    class="text-red-500"
                >
                    Invalid Email
                </div>
                </div>
                <div class="w-full gap-2 flex flex-col">
                <span>Merchant Transaction SMS</span>

                <input
                    formControlName="MerchantTransactionSMS"
                    name="MerchantTransactionSMS"
                    placeholder="Merchant Transaction SMS"
                    class="w-full border p-2 rounded-md outline-none"
                />
                </div>
            </div>
            </div> -->
  <!-- </div> -->
</div>

<!-- <div class="bg-white rounded-lg py-3 px-12 flex justify-end gap-4">
  <button class="bg-[#0000000a] rounded-lg py-2 px-4">Save</button>
  <button class="bg-[#0058e9] rounded-lg py-2 px-4 text-white">Draft</button>
</div> -->
